import React from 'react';
import { Search, Command } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { setSearchOpen } from '../../store/slices/uiSlice';

export default function NavSearch() {
  const dispatch = useDispatch();

  return (
    <button
      onClick={() => dispatch(setSearchOpen(true))}
      className="group relative flex h-9 w-full items-center gap-3 rounded-xl border border-border bg-accent/30 px-3 pr-2 text-sm text-muted-foreground transition-all hover:bg-accent/50 hover:border-primary/20 md:w-[260px] lg:w-[300px] xl:w-[340px] focus:outline-none focus:ring-1 focus:ring-primary/20"
    >
      <Search className="h-4 w-4 shrink-0 transition-colors group-hover:text-primary" />
      <span className="flex-1 text-left opacity-70 group-hover:opacity-100 transition-opacity">Search or type ⌘K...</span>
      <div className="hidden items-center gap-1 rounded-md border border-border/50 bg-background/50 px-1.5 py-0.5 text-[10px] font-bold tracking-tighter sm:flex">
        <Command className="h-2.5 w-2.5" />
        <span>K</span>
      </div>
    </button>
  );
}
